<ng-container *ngIf="extendedAttachmentMedia$ | async as extendedAttachmentMedia">
  <div class="attachments-actions">
    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      type="button"
      mat-raised-button
      (click)="addAttatchmentHandler(extendedAttachmentMedia)">
      {{ 'Aggiungi allegato' | translate }}
    </button>
  </div>
  <div [formGroup]="form">
    <ui-draggable-list
      *ngIf="extendedAttachmentMedia?.length > 0; else noItems"
      [items]="extendedAttachmentMedia"
      (dropComplete)="orderAttachmentHandler($event)">
      <ng-template
        uiListItem
        let-i="index"
        let-item="item">
        <div
          class="attachment-container"
          [formArrayName]="i">
          <div
            class="attachment-actions"
            *roleVisibility="['create', 'update']; classNames: classNames">
            <button
              mat-icon-button
              type="button"
              (click)="removeAttachmentHandler(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <div class="attachment-info-container">
            <img
              *ngIf="item?.file?.previewUrl"
              class="attachment-preview-img"
              loading="lazy"
              [src]="item?.file?.previewUrl"
              (click)="showMediaHandler(item)">
            <div class="attachment-details">
              <mat-form-field class="input-expanse">
                <input
                  matInput
                  formControlName="descrizione"
                  class="input-expanse"
                  [placeholder]="'Descrizione' | translate">
              </mat-form-field>
              <small class="attachment-info">
                {{ 'Nome' | translate }}: {{ item?.file.name  }}
              </small>
              <small class="attachment-info">
                {{ 'Note' | translate }}: {{ item?.file.note  }}
              </small>
              <small class="attachment-info">
                {{ 'Tags' | translate }}: {{ item?.file.tags?.join(', ') }}
              </small>
            </div>
          </div>
        </div>
      </ng-template>
    </ui-draggable-list>

    <ng-template #noItems>
      <ui-no-items [size]="40"></ui-no-items>
    </ng-template>
  </div>
</ng-container>
